import React, { createContext, useContext, useState, useEffect } from "react";
import { getUser } from "../services/authService.js";
import { getAllNotifications } from "../services/notificationsService.js";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [accessToken, setAccessToken] = useState(localStorage.getItem("access-token"));
	const [refreshToken, setRefreshToken] = useState(localStorage.getItem("refresh-token"));
	const [loading, setLoading] = useState(true);
	const [notifications, setNotifications] = useState([]);

	const login = (at, rt, user) => {
		localStorage.setItem("access-token", at);
		localStorage.setItem("refresh-token", rt);
		setAccessToken(at);
		setRefreshToken(rt);
		setUser({ ...user });
	};

	const logout = () => {
		localStorage.removeItem("refresh-token");
		localStorage.removeItem("access-token");
		setUser(null);
		setAccessToken(null);
		setRefreshToken(null);
		setLoading(false);
		setNotifications([]);
	};

	useEffect(() => {
		const getUserNotifications = () => {
			if (!user || !accessToken) return;
			getAllNotifications().then((response) => setNotifications(response.data.notifications));
		};
		if (!user || !accessToken) return;
		getUserNotifications();
		const interval = setInterval(getUserNotifications, 60 * 1000);
		return () => clearInterval(interval);
	}, [user, accessToken]);

	// Fetch user details
	useEffect(() => {
		const fetchUser = async () => {
			if (accessToken) {
				setLoading(true);
				try {
					const response = await getUser();
					setUser(response.data);
				} catch (err) {
					console.error("Errore nel recupero dei dettagli utente:", err);
					logout();
				} finally {
					setLoading(false);
				}
			} else setLoading(false);
		};
		fetchUser();
	}, [accessToken]);

	const value = {
		user,
		accessToken,
		notifications,
		setAccessToken,
		refreshToken,
		loading,
		login,
		logout,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useAuth deve essere usato all'interno di un AuthProvider");
	}
	return context;
};
